console.log("script init");

// const backorderMessage = document.querySelector(".backorder-message");

// if(backorderMessage)
// {
//     const customerCountry = Shopify.country;

//     const variantData = "";

//     if(customerCountry == "CA"){

//     }
// }




// document.addEventListener("DOMContentLoaded", () => {

//     const backorder = document.querySelector(".backorder-message");

//     if (!backorder) return;

//     const variants = JSON.parse(backorder.dataset.variants);

//     function updateMessage(variant) {

//         if (!variant) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         const metafieldData = variants[variant.id];

//         if (!metafieldData) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         const shouldShow =
//             variant.inventory_policy === "continue" &&
//             variant.inventory_quantity <= 0;

//         if (!shouldShow) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         let message = "";

//         switch (Shopify.country) {

//             case "US":
//                 message = metafieldData.usa;
//                 break;

//             case "CA":
//                 message = metafieldData.canada;
//                 break;

//             default:
//                 message = "";
//         }

//         if (message) {
//             backorder.innerHTML = message;
//             backorder.style.display = "block";
//         } else {
//             backorder.innerHTML = "";
//             backorder.style.display = "none";
//         }

//     }

//     /* Initial variant */
//     const picker = document.querySelector("variant-picker");

//     if (picker?.selectedVariant) {
//         console.log("Initial Variant:", picker.selectedVariant);
//         updateMessage(picker.selectedVariant);
//     }

//     /* Prestige native event */
//     document.addEventListener("variant:change", function(e){
//     console.log("variant changed");
//     console.log(e.detail.variant);
//     console.log("Shopify Country:", Shopify.country);
//         if (!e.detail.variant) return;

//         updateMessage(e.detail.variant);

//     });

// });


document.addEventListener("DOMContentLoaded", () => {

  console.log("Backorder script loaded");
   /*
  ==========================================
  SKIP GIFT CARD PRODUCT
  ==========================================
  */

  if (window.location.pathname === "/products/gift-card") {
    console.log("Gift card product - backorder script skipped");
    return;
  }

  /* =========================================
     GET CURRENT BACKORDER ELEMENT
  ========================================= */

  function getBackorderElement() {
    return document.querySelector(".backorder-message");
  }

  function updateAddToCart(variantData, country) {

  const button = document.querySelector(
    "buy-buttons button[type='submit']"
  );

  if (!button) {
    console.log("ATC button not found");
    return;
  }

  const inventoryQuantity = Number(
    variantData["inventory-quantity"]
  );

  const continueSelling =
    variantData["continue-selling"] === "continue";


  /*
  ==========================================
  COUNTRY ALLOW BACKORDER
  ==========================================
  */

  let allowBackorder = true;

  if (country === "US") {

    allowBackorder =
      variantData["us-allow-backorder"] === true;

  } else if (country === "CA") {

    allowBackorder =
      variantData["ca-allow-backorder"] === true;

  }


  console.log("Country:", country);
  console.log("Inventory:", inventoryQuantity);
  console.log("Continue Selling:", continueSelling);
  console.log("Allow Backorder:", allowBackorder);


  /*
  ==========================================
  CONDITION 1
  CONTINUE SELLING + COUNTRY NOT ALLOWED
  ==========================================
  */

  if (
    inventoryQuantity <= 0 &&
    continueSelling &&
    !allowBackorder
  ) {

    button.disabled = true;

    button.setAttribute(
      "aria-disabled",
      "true"
    );

    button.textContent = "Sold Out";

    console.log(
      "ATC DISABLED - Backorder not allowed"
    );

    return;
  }


  /*
  ==========================================
  CONDITION 2
  DENY + INVENTORY 0
  ==========================================
  */

  if (
    inventoryQuantity <= 0 &&
    !continueSelling
  ) {

    button.disabled = true;

    button.setAttribute(
      "aria-disabled",
      "true"
    );

    button.textContent = "Out of Stock";

    console.log(
      "ATC DISABLED - Shopify inventory policy deny"
    );

    return;
  }


  /*
  ==========================================
  ALL OTHER CONDITIONS
  ==========================================
  */

  button.disabled = false;

  button.removeAttribute(
    "aria-disabled"
  );

  button.textContent = "Add to cart";

  console.log(
    "ATC ENABLED"
  );
}
  // /* =========================================
  //    GET CURRENT ADD TO CART BUTTON
  // ========================================= */

  // function getAddToCartButton() {
  //   return document.querySelector(
  //     "buy-buttons button[type='submit']"
  //   );
  // }


  // /* =========================================
  //    UPDATE ADD TO CART
  // ========================================= */

  // function updateAddToCart(variantData) {

  //   const button = getAddToCartButton();

  //   if (!button) {
  //     console.log("ATC button not found");
  //     return;
  //   }

  //   const inventoryQuantity =
  //     Number(variantData["inventory-quantity"]);

  //   console.log("Inventory:", inventoryQuantity);


  //   /*
  //     INVENTORY AVAILABLE
  //   */

  //   if (inventoryQuantity > 0) {

  //     button.disabled = false;
  //     button.removeAttribute("aria-disabled");
  //     button.textContent = "Add to cart";

  //     console.log("ATC ENABLED");

  //     return;
  //   }


  //   /*
  //     INVENTORY 0 OR BELOW
  //     ALWAYS DISABLE ATC
  //   */

  //   button.disabled = true;
  //   button.setAttribute("aria-disabled", "true");
  //   button.textContent = "Sold Out";

  //   console.log("ATC DISABLED");
  // }


  /* =========================================
     UPDATE BACKORDER MESSAGE
  ========================================= */

  function updateMessage(variant) {

    if (!variant || !variant.id) {
      console.log("No variant selected");
      return;
    }


    console.log("Selected Variant:", variant);


    /*
      IMPORTANT:
      Get the CURRENT element because Prestige
      can replace it after variant change.
    */

    const backorder = getBackorderElement();

    if (!backorder) {
      console.log("Backorder element not found");
      return;
    }


    /*
      GET VARIANT JSON
    */

    const json =
      backorder.getAttribute("data-variants");

    if (!json) {
      console.log("data-variants not found");
      return;
    }


    let variants;

    try {

      variants = JSON.parse(json);

    } catch (error) {

      console.error("JSON error:", error);

      return;
    }


    /*
      GET SELECTED VARIANT DATA
    */

    const variantId = String(variant.id);

    const variantData = variants[variantId];


    console.log("Variant ID:", variantId);
    console.log("Variant Data:", variantData);


    if (!variantData) {

      console.log(
        "Variant data not found:",
        variantId
      );

      backorder.innerHTML = "";
      backorder.style.display = "none";

      return;
    }


    /*
      =========================================
      INVENTORY
      =========================================
    */

    const inventoryQuantity =
      Number(variantData["inventory-quantity"]);


    /*
      =========================================
      CONTINUE SELLING
      =========================================
    */

    const continueSelling =
      variantData["continue-selling"] === "continue";


    /*
      =========================================
      COUNTRY
      =========================================
    */

    const country =
      backorder.getAttribute("data-country");


    console.log("Country:", country);
    console.log(
      "Continue Selling:",
      continueSelling
    );
    console.log(
      "Inventory:",
      inventoryQuantity
    );


    /*
      =========================================
      COUNTRY BACKORDER SETTING
      =========================================
    */

    let allowBackorder = false;
    let message = "";


    if (country === "US") {

      allowBackorder =
        variantData["us-allow-backorder"] === true;

      message =
        variantData["backorder-USA"] || "";

    }


    if (country === "CA") {

      allowBackorder =
        variantData["ca-allow-backorder"] === true;

      message =
        variantData["backorder-Canada"] || "";

    }


    console.log(
      "Allow Backorder:",
      allowBackorder
    );

    console.log(
      "Message:",
      message
    );


    /*
      =========================================
      UPDATE ATC
      =========================================

      This is completely independent
      from allowBackorder.

      Inventory > 0
      = ATC enabled

      Inventory <= 0
      = ATC disabled
    */

    updateAddToCart(variantData, country);


    /*
      =========================================
      BACKORDER MESSAGE
      =========================================

      Only show when:

      Inventory <= 0
      AND
      Continue selling = continue
      AND
      Country Allow Backorder = true
    */

    if (
      inventoryQuantity <= 0 &&
      continueSelling &&
      allowBackorder
    ) {

      if (message) {

        backorder.innerHTML = message;
        backorder.style.display = "block";

        console.log(
          "Backorder message SHOWN"
        );

      } else {

        backorder.innerHTML = "";
        backorder.style.display = "none";

      }

    } else {

      backorder.innerHTML = "";
      backorder.style.display = "none";

      console.log(
        "Backorder message HIDDEN"
      );
    }

  }


  /* =========================================
     INITIAL SELECTED VARIANT
  ========================================= */

  function initializeVariant() {

    const picker =
      document.querySelector("variant-picker");


    if (
      picker &&
      picker.selectedVariant
    ) {

      console.log(
        "Initial Variant:",
        picker.selectedVariant
      );

      updateMessage(
        picker.selectedVariant
      );

      return true;
    }

    return false;
  }


  initializeVariant();


  /* =========================================
     PRESTIGE VARIANT CHANGE
  ========================================= */

  document.addEventListener(
    "variant:change",
    function(event) {

      console.log(
        "========== VARIANT CHANGED =========="
      );


      const variant =
        event.detail?.variant;


      if (!variant) {
        return;
      }


      /*
        Prestige can re-render the product
        elements, so wait briefly.
      */

      setTimeout(() => {

        updateMessage(variant);

      }, 100);

    }
  );


  /* =========================================
     FALLBACK INITIALIZATION
  ========================================= */

  setTimeout(() => {

    initializeVariant();

  }, 500);


  setTimeout(() => {

    initializeVariant();

  }, 1500);

});

// document.addEventListener("DOMContentLoaded", () => {

//     const backorder = document.querySelector(".backorder-message");

//     if (!backorder) return;

//     const variants = JSON.parse(backorder.dataset.variants);

//     function updateMessage(variant) {

//         if (!variant) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         console.log("Selected Variant:", variant);

//         const metafieldData = variants[variant.id];

//         console.log("JSON Data:", metafieldData);

//         if (!metafieldData) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         // ✅ Use your JSON values instead of variant.inventory_policy
//         const shouldShow =
//             metafieldData["continue-selling"] === "continue" &&
//             Number(metafieldData["inventory-quantity"]) <= 0;

//         console.log("Should Show:", shouldShow);

//         if (!shouldShow) {
//             backorder.style.display = "none";
//             backorder.innerHTML = "";
//             return;
//         }

//         let message = "";

//         const country = window.customerCountry || Shopify.country;

//         console.log("Country:", country);

//         switch (country) {

//             case "US":
//                 message = metafieldData["backorder-USA"];
//                 break;

//             case "CA":
//                 message = metafieldData["backorder-Canada"];
//                 break;

//             default:
//                 message = "";
//         }

//         console.log("Message:", message);

//         if (message) {
//             backorder.innerHTML = message;
//             backorder.style.display = "block";
//         } else {
//             backorder.innerHTML = "";
//             backorder.style.display = "none";
//         }
//     }

//     // Initial selected variant
//     const picker = document.querySelector("variant-picker");

//     if (picker && picker.selectedVariant) {
//         console.log("Initial Variant:", picker.selectedVariant);
//         updateMessage(picker.selectedVariant);
//     }

//     // Prestige event
//     document.addEventListener("variant:change", function (e) {

//         console.log("Variant Changed");

//         if (!e.detail.variant) return;

//         updateMessage(e.detail.variant);

//     });

// });
